import React from 'react';
import { Breadcrumbs, Typography } from '@material-ui/core';
import RoomRoundedIcon from '@material-ui/icons/RoomRounded';
import { HomeLink } from '../HomeLink/HomeLink';
import MapRoundedIcon from '@material-ui/icons/MapRounded';
import { Paths } from '../../../helpers/constants';
import { BreadcrumbLink } from '../BreadcrumbLink';

interface Props {
    cityName?: string,
}

export const MapViewCityBreadcrumbs = ({ cityName }: Props) => {
    return (
        <>
            <Breadcrumbs aria-label="breadcrumb" data-nosnippet>
                <HomeLink />
                <BreadcrumbLink
                    to={Paths.map.map}
                    text='Mapa'
                    icon={<MapRoundedIcon style={{ width: 20, height: 20 }} />
                    }
                />
                <Typography color="textPrimary" style={{ display: 'flex' }}>
                    <RoomRoundedIcon style={{ width: 20, height: 20 }} />
                    {cityName}
                </Typography>
            </Breadcrumbs>
            <br></br>
        </>
    );
}